<template>
  <List class="profile-items">
    <slot />
  </List>
</template>

<script>
import { List } from '@campsite-bio/component-lib';

export default {
  components: {
    List,
  },
};
</script>

<style lang="scss" scoped>
.profile-items.profile-items {
  background: none;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0;
}
</style>
